import { $Qll } from "../utils/query-selector";

const processTrackingShipping = async (event) => {
  event.preventDefault();
  window.location.href = "/checkout?discount=TRADER"
};

const initTrackingShipping = () => {
  const { customer } = window;
  if (!customer) return;

  const { tags } = customer;

  if (!tags.includes("trader")) return;

  const checkoutBtn = $Qll(".cartpage-footer__btn--btn");

  if (!checkoutBtn.length) return;

  checkoutBtn.forEach((button) => {
    button.addEventListener('click', processTrackingShipping);
  });
};

export { initTrackingShipping };
